export default "__VITE_ASSET__CWtpt_dD__"